import { useState } from 'react';
import { useIntl } from 'react-intl';
import { Col, Row } from 'reactstrap';
import Toast from '../../helpers/Toast';
import { Utilities } from '../../helpers/Utilities';
import { CreateScheduleDTO } from '../../models/Scheduler/CreateScheduleDTO';
import { SchedulerService } from '../../services/SchedulerService';
import ButtonComponent from '../ButtonComponent';
import InputComponent from '../InputComponent';
import SelectComponent from '../SelectComponent';
import { EditScheduleDTO } from '../../models/Scheduler/EditScheduleDTO';
import CancelScheduleComponent from './CancelScheduleComponent';

type EditSchedulerSecondTabProps = {
    scheduleDTO: EditScheduleDTO;
    setScheduleDTO: React.Dispatch<React.SetStateAction<EditScheduleDTO>>;

    onClose: () => void;
};

function EditSchedulerSecondTab(props: EditSchedulerSecondTabProps) {

    const [isEditingSchedulingLoading, setIsEditingSchedulingLoading] = useState<boolean>(false);

    const [isCancellingSchedulingLoading, setIsCancellingSchedulingLoading] = useState<boolean>(false);
    const [isEditScheduleComponentOpen, setIsEditScheduleComponentOpen] = useState<boolean>(false);

    const schedulerService = new SchedulerService();
    const intl = useIntl();

    const [startDate, setStartDate] = useState<string>(
        props.scheduleDTO.startDate ? Utilities.formatDateYYYYMMDD(new Date(props.scheduleDTO.startDate)) : Utilities.formatDateYYYYMMDD(new Date())
    );
    const [startTime, setStartTime] = useState<string>(
        props.scheduleDTO.startDate ? Utilities.GetTimeFromDateTime(new Date(props.scheduleDTO.startDate)) : Utilities.GetTimeFromDateTime(new Date())
    );
    const [endDate, setEndDate] = useState<string>(
        props.scheduleDTO.endDate ? Utilities.formatDateYYYYMMDD(new Date(props.scheduleDTO.endDate)) : Utilities.formatDateYYYYMMDD(new Date())
    );
    const [endTime, setEndTime] = useState<string>(
        props.scheduleDTO.endDate ? Utilities.GetTimeFromDateTime(new Date(props.scheduleDTO.endDate)) : Utilities.GetTimeFromDateTime(new Date())
    );
    const [notes, setNotes] = useState<string>(props.scheduleDTO.notes || '');
    const [technician, setTechnician] = useState<string>(props.scheduleDTO.technicianCode || '');

    const EditScheduler = async () => {
        setIsEditingSchedulingLoading(true);

        const editSchedule: EditScheduleDTO = {
            scheduleId: props.scheduleDTO.scheduleId || null,
            assistanceId: props.scheduleDTO.assistanceId || null,
            clientErpId: props.scheduleDTO.clientErpId || null,
            equipmentErpId: props.scheduleDTO.equipmentErpId || null,

            startDate: startDate ? Utilities.CombineDateAndTime(new Date(startDate), startTime) : props.scheduleDTO.startDate ? props.scheduleDTO.startDate : null,
            endDate: endDate ? Utilities.CombineDateAndTime(new Date(endDate), endTime) : props.scheduleDTO.endDate !== null ? props.scheduleDTO.endDate : null,
            notes: notes ?? props.scheduleDTO.notes ?? null,
            observations: props.scheduleDTO.observations ?? props.scheduleDTO.observations ?? '',
            technicianCode: technician ?? props.scheduleDTO.technicianCode ?? null,

            type: props.scheduleDTO.type,
        };

        const response = await schedulerService.Edit(editSchedule);
        if (response.success == false) {
            setIsEditingSchedulingLoading(false);
            Toast.Show("error", response.message);
            return;
        }

        setIsEditingSchedulingLoading(false);
        Toast.Show("success", response.message);
        props.onClose();
    };

    return (
        <div>
            <Row
                style={{
                    margin: "5% 0% 0% 0%",
                    padding: "0px",
                    alignItems: "flex-end",
                    alignContent: "flex-end",
                }}
            >
                <InputComponent
                    xl={3}
                    lg={3}
                    md={3}
                    sm={12}
                    xs={12}
                    style={{ width: "100%" }}
                    type={"date"}
                    value={startDate}
                    label={`Dia Inicial ${props.scheduleDTO.type}`}
                    readOnly={false}
                    onChange={(t: string) => {
                        setStartDate(t);
                        setEndDate(t);

                        const start = new Date(t + 'T' + startTime);
                        const end = new Date(t + 'T' + endTime);

                        props.setScheduleDTO({
                            ...props.scheduleDTO,
                            startDate: start,
                            endDate: end,
                        });
                    }}
                />
                <InputComponent
                    xl={3}
                    lg={3}
                    md={3}
                    sm={3}
                    xs={12}
                    style={{ width: "100%" }}
                    type={"time"}
                    value={startTime}
                    label={`Hora Inicial ${props.scheduleDTO.type}`}
                    readOnly={false}
                    onChange={(t: string) => {
                        setStartTime(t);

                        const start = new Date(startDate + 'T' + t);
                        const currentEnd = new Date(endDate + 'T' + endTime);

                        let updatedEnd = currentEnd;

        
                        if (currentEnd <= start) {
                            updatedEnd = new Date(start);
                            updatedEnd.setMinutes(start.getMinutes() + 15);

                            const formattedEndTime = updatedEnd.toTimeString().substring(0, 5);
                            setEndTime(formattedEndTime);
                        }

                        props.setScheduleDTO({
                            ...props.scheduleDTO,
                            startDate: start,
                            endDate: updatedEnd,
                        });
                    }}
                />
            </Row>
            <Row
                style={{
                    margin: "0px",
                    padding: "0px",
                    alignItems: "flex-end",
                    alignContent: "flex-end",
                }}
            >
                <InputComponent
                    xl={3}
                    lg={3}
                    md={3}
                    sm={12}
                    xs={12}
                    style={{ width: "100%" }}
                    type={"date"}
                    value={endDate}
                    label={`Dia Final ${props.scheduleDTO.type}`}
                    readOnly={false}
                    onChange={(t: string) => {
                        setEndDate(t);
                        props.setScheduleDTO({
                            ...props.scheduleDTO,
                            endDate: new Date(t + 'T' + endTime)
                        });
                    }}
                />
                <InputComponent
                    xl={3}
                    lg={3}
                    md={3}
                    sm={3}
                    xs={12}
                    style={{ width: "100%" }}
                    type={"time"}
                    value={endTime}
                    label={`Hora Final ${props.scheduleDTO.type}`}
                    readOnly={false}
                    onChange={(t: string) => {
                        setEndTime(t);
                        props.setScheduleDTO({
                            ...props.scheduleDTO,
                            endDate: new Date(endDate + 'T' + t)
                        });
                    }}
                />
            </Row>

            <Row
                style={{
                    margin: "0px",
                    padding: "0px",
                    alignItems: "flex-end",
                    alignContent: "flex-end",
                }}
            >
                <InputComponent
                    xl={12}
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    style={{ width: "100%" }}
                    type={"textArea"}
                    value={notes}
                    label={`Observações ${props.scheduleDTO.type}`}
                    readOnly={false}
                    onChange={(t: string) => {
                        setNotes(t);
                        props.setScheduleDTO({
                            ...props.scheduleDTO,
                            notes: t
                        });
                    }}
                />
            </Row>

            <Row
                style={{
                    margin: "0px",
                    padding: "0px",
                    alignItems: "flex-end",
                    alignContent: "flex-end",
                }}
            >
                <SelectComponent
                    xl={6}
                    lg={6}
                    md={6}
                    sm={12}
                    xs={12}
                    style={{ width: "100%", height: "43px" }}
                    label={`Técnico ${props.scheduleDTO.type}`}
                    selectedItemValue={technician}
                    items={Utilities.GetTechnicians}
                    onChange={(t: string) => {
                        setTechnician(t);
                        props.setScheduleDTO({
                            ...props.scheduleDTO,
                            technicianCode: t
                        });
                    }}
                />
            </Row>

            <Row
                style={{
                    margin: "2% 0% 0% 0%",
                    padding: "0px",
                    alignItems: "flex-end",
                    alignContent: "flex-end",
                }}
            >

                <Col xl={3} lg={3} md={3} sm={12} xs={12}>
                    <ButtonComponent
                        disabled={isEditingSchedulingLoading}
                        loading={isEditingSchedulingLoading}
                        text={intl.formatMessage({ id: "Screens.EditScheduler.SecondTab.Button.Edit" })} // mudar para dinamico?
                        onClick={EditScheduler}
                        style={{ width: "100%" }}
                    />
                </Col>

                <Col xl={3} lg={3} md={3} sm={12} xs={12}>
                    <ButtonComponent
                        disabled={isCancellingSchedulingLoading}
                        loading={isCancellingSchedulingLoading}
                        text={intl.formatMessage({ id: "Screens.EditScheduler.SecondTab.Button.Cancel" })} // mudar para dinamico?
                        onClick={() => {
                            setIsEditScheduleComponentOpen(true);
                        }}
                        style={{ width: "100%" }}
                    />
                </Col>
            </Row>

            {isEditScheduleComponentOpen && (
                <Col xl={12}>
                    <CancelScheduleComponent
                        scheduleId={props.scheduleDTO.scheduleId}
                        onClose={props.onClose}
                    />
                </Col>
            )}
        </div>
    )
}

export default EditSchedulerSecondTab;